import { RefObject, useEffect } from "react"

const useClickOutside = (refs: RefObject<HTMLElement> | RefObject<HTMLElement>[], callback: () => void) => {
  useEffect(() => {
    const refList = Array.isArray(refs) ? refs : [refs]
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (!refList.some(ref => ref.current?.contains(target))) {
        callback()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [refs, callback])
}

export default useClickOutside
